import { useState, useEffect } from "react";
import { CustomInput } from "../../../../components/CustomInput";
import { useCustomTheme } from "../../../../hooks/useCustomTheme";
import { ContainerDados, ContainerRow } from "./styles";
import { ImageUploader } from "../../../../components/ImageUploader";
import { CustomSelectPicker } from '../../../../components/CustomSelectPicker';
import { IMAGES_PATH } from "../../../../utils/imagesPath";

const dataAtivo = [
  { value: '0', label: 'Não' },
  { value: '1', label: 'Sim' },
];

const DadosBanner = ({ 
  descricao,
  setDescricao,
  imagemFile, 
  setImagemFile,
  banner, 
  setStatus
}) => {
  const { theme } = useCustomTheme();
  const [imagemPreview, setImagemPreview] = useState(null); 
  const MandatoryTag = () => <span style={{ color: '#f00' }}>*</span>;

  const saveBanner = (imageBlob) => {
    if (imageBlob) {
      setImagemFile(imageBlob);
      setImagemPreview(URL.createObjectURL(imageBlob));
    }
  }

  const removeBanner = () => {
    setImagemFile(null);
    setImagemPreview(null);
  }

  useEffect(() => {
    if(banner){
      setDescricao(banner ? banner.Descricao : '');
      setImagemPreview(banner && banner.Imagem ? 
        `${IMAGES_PATH}${banner.Imagem}` : null);
      setStatus(banner.Ativo ? '1' : '0');
    }
  },[banner])

  useEffect(() => {
    return () => {
      if (imagemFile) {
        URL.revokeObjectURL(imagemPreview);
      }
    };
  }, [imagemFile, imagemPreview]);

  return (
    <ContainerDados> 
      <ContainerRow>
        <label htmlFor="descricao">
          <b style={{ color: theme.colors.textSecondary }}>
            Descrição <MandatoryTag />
          </b>
        </label>
        <CustomInput type="text" value={descricao} onChange={setDescricao} />
      </ContainerRow>
      <ContainerRow>
        <label htmlFor="descricao">
          <b style={{ color: theme.colors.textSecondary }}>
            Imagem (Proporção 1147 X 110)
          </b>
        </label>  
        <ImageUploader
          src={imagemPreview}
          save={saveBanner}
          remove={removeBanner}
          width={440}
        />
      </ContainerRow>
      {banner && (
        <ContainerRow>
          <label htmlFor="status">
            <b style={{ color: theme.colors.textSecondary }}>Ativo</b>
          </label>
          <CustomSelectPicker
            data={dataAtivo}
            onChange={setStatus}
            defaultValue={
                banner.Ativo ? dataAtivo[1].value : dataAtivo[0].value
            }
          />
        </ContainerRow>
      )}
  </ContainerDados>)
}

export default DadosBanner;